$(document).ready(function (e) {
    // get full height ( except ios address bar )
    getFullHeight();
    // Toggle
    $(".nursery-news__title").on("click", function () {
        $(this).next().slideToggle();
        $(this).toggleClass("open");
    });
});

$(window).resize(function () {
    // get full height ( except ios address bar )
    getFullHeight();
});

function getFullHeight() {
    const win_w = $(window).width();
    const win_h = $(window).height() - 56;
    // SPのみ
    if (win_w <= 600) {
        $(".nursery-cover").height(win_h);
        $(".nursery-cover__container").height(win_h);
        $(".hokatsu-one-stop-top").css("padding-top", win_h);
        if ($(window).height() < 700) {
            $(".nursery-cover__catch img").css("width", "52%");
        }
    }
}
